module.exports = __webpack_public_path__ + "static/media/simon_1.6af8037b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ExampleCarousel/assets/simon_1.jpg
// module id = 453
// module chunks = 0